/* ============================================
   NIRVANA BITES — Theme JS
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

/* === STICKY HEADER === */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* === NB STICKY HEADER (glossy on stuck) === */
  const nbHeader = document.querySelector('.nb-header');
  if (nbHeader) {
    const updateStuck = () => {
      nbHeader.classList.toggle('is-stuck', window.pageYOffset > 1);
    };
    updateStuck();
    window.addEventListener('scroll', updateStuck, { passive: true });
    window.addEventListener('resize', updateStuck);
  }

/* === MOBILE MENU === */
  const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileClose = document.querySelector('[data-mobile-menu-close]');
  const mobileOverlay = document.querySelector('[data-mobile-menu-overlay]');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (mobileOverlay) mobileOverlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (mobileOverlay) mobileOverlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      mobileMenu.classList.contains('is-open') ? closeMobileMenu() : openMobileMenu();
    });

    if (mobileClose) {
      mobileClose.addEventListener('click', closeMobileMenu);
    }

    if (mobileOverlay) {
      mobileOverlay.addEventListener('click', closeMobileMenu);
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeMobileMenu();
    });

    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', closeMobileMenu);
    });
  }

  /* === CART DRAWER === */
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  if (cartToggle) {
    cartToggle.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    });
  }

  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const itemsContainer = document.querySelector('[data-cart-items]');
      const countEl = document.querySelector('[data-cart-count]');
      const subtotalEl = document.querySelector('[data-cart-subtotal]');

      if (countEl) countEl.textContent = cart.item_count;
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      if (itemsContainer) {
        if (cart.items.length === 0) {
          itemsContainer.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections/all" class="btn btn--primary">Shop Now</a></div>';
          return;
        }

        itemsContainer.innerHTML = cart.items.map(item => `
          <div class="cart-drawer__item" data-cart-item="${item.key}">
            <div class="cart-drawer__item-image">
              <img src="${item.image}" alt="${item.title}" width="80" height="80" loading="lazy">
            </div>
            <div>
              <p class="cart-drawer__item-title">${item.title}</p>
              ${item.variant_title ? `<p class="cart-drawer__item-variant">${item.variant_title}</p>` : ''}
              <p class="cart-drawer__item-price">${formatMoney(item.price)}</p>
              <div class="cart-drawer__item-quantity">
                <button data-quantity-minus="${item.key}" aria-label="Decrease">-</button>
                <span>${item.quantity}</span>
                <button data-quantity-plus="${item.key}" aria-label="Increase">+</button>
              </div>
            </div>
          </div>
        `).join('');

        itemsContainer.querySelectorAll('[data-quantity-minus]').forEach(btn => {
          btn.addEventListener('click', () => updateQuantity(btn.dataset.quantityMinus, -1));
        });
        itemsContainer.querySelectorAll('[data-quantity-plus]').forEach(btn => {
          btn.addEventListener('click', () => updateQuantity(btn.dataset.quantityPlus, 1));
        });
      }
    } catch (err) {
      console.error('Cart refresh error:', err);
    }
  }

  async function updateQuantity(key, change) {
    const item = document.querySelector(`[data-cart-item="${key}"]`);
    if (!item) return;
    const qtySpan = item.querySelector('span');
    const currentQty = parseInt(qtySpan.textContent);
    const newQty = currentQty + change;
    if (newQty < 1) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
    } else {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      });
    }
    refreshCart();
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* === ADD TO CART (AJAX) === */
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (res.ok) {
          openCart();
        }
      } catch (err) {
        console.error('Add to cart error:', err);
      }
    });
  });

  /* === QUANTITY SELECTOR === */
  document.querySelectorAll('.quantity-selector button').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (btn.textContent === '-') val = Math.max(1, val - 1);
      else val += 1;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* === PRODUCT GALLERY THUMBS === */
  const mainImage = document.querySelector('.product-gallery__main img');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  if (mainImage && thumbs.length) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const img = thumb.querySelector('img');
        if (img) {
          mainImage.src = img.src;
          mainImage.srcset = img.srcset || '';
          thumbs.forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
        }
      });
    });
  }

  /* === DROPDOWN NAV === */
  document.querySelectorAll('[data-dropdown-trigger]').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
    });
  });

});
